module.exports = __webpack_public_path__ + "img/hk.326fa1da.svg";